export const locale = {
    lang: 'ar',
    data: {
        PROJECTS_DIALOGS_NEW_DIALOG_ADD_PARAGRAPHE: 'إضافَة فقرة',
        PROJECTS_DIALOGS_NEW_DIALOG_TITLE: 'عنوان',
        PROJECTS_DIALOGS_NEW_DIALOG_SAVE: 'حفظ',
        PROJECTS_DIALOGS_NEW_DIALOG_CANCEL: 'إلغاء',
    }
};
